import { Component, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-sale-svinn',
  templateUrl: './sale-svinn.component.html',
})
export class AppSaleSvinnComponent implements OnInit {

  @Input() salesReport: Array<any> = []
  @Input() svinnReport: Array<any> = []


mergedData: any[] = [];
categories: string[] = [];
dates: string[] = [];
salesDataMap = new Map();
svinnDataMap = new Map();

ngOnInit() {
  this.processData();
}

processData() {
  // Step 1: Get unique categories and dates
  this.extractUniqueDatesAndCategories();

  // Step 2: Populate salesDataMap
  this.salesReport.forEach(saleEntry => {
    saleEntry.forEach(entry => {
      const key = `${entry.formatted}-${entry.body.categories[0]}`;
      this.salesDataMap.set(key, entry.serverData.count);
    });
  });

  // Step 3: Populate svinnDataMap
  this.svinnReport.forEach(svinnEntry => {
    svinnEntry.forEach(entry => {
      const key = `${entry.formatted}-${entry.body.categories[0]}`;
      this.svinnDataMap.set(key, entry.serverData.count);
    });
  });
}

extractUniqueDatesAndCategories() {
  const dateSet = new Set<string>();
  const categorySet = new Set<string>();

  // Loop through salesReport to get unique dates and categories
  this.salesReport.forEach(saleEntry => {
    saleEntry.forEach(entry => {
      dateSet.add(entry.formatted);
      categorySet.add(entry.body.categories[0]);
    });
  });

  // Similarly for svinnReport
  this.svinnReport.forEach(svinnEntry => {
    svinnEntry.forEach(entry => {
      dateSet.add(entry.formatted);
      categorySet.add(entry.body.categories[0]);
    });
  });

  this.dates = Array.from(dateSet);
  this.categories = Array.from(categorySet);
}

// Get sale for a specific date and category
getSale(date: string, category: string): number | null {
  const key = `${date}-${category}`;
  return this.salesDataMap.get(key) || 0;
}

// Get svinn for a specific date and category
getSvinn(date: string, category: string): number | null {
  const key = `${date}-${category}`;
  return this.svinnDataMap.get(key) || 0;
}

// Calculate difference (sale - svinn)
getDifference(date: string, category: string): number | null {
  const sale = this.getSale(date, category);
  const svinn = this.getSvinn(date, category);
  return sale - svinn;
}

// Calculate total sale for a specific category across all dates
getTotalSale(category: string): number {
  let totalSale = 0;
  this.dates.forEach(date => {
    totalSale += this.getSale(date, category);
  });
  return totalSale;
}

// Calculate total svinn for a specific category across all dates
getTotalSvinn(category: string): number {
  let totalSvinn = 0;
  this.dates.forEach(date => {
    totalSvinn += this.getSvinn(date, category);
  });
  return totalSvinn;
}


getTotalSvinnPercent(category: string): Number {
  let totalSale = 0;
  this.dates.forEach(date => {
    totalSale += this.getSale(date, category);
  });


  let totalSvinn = 0;
  this.dates.forEach(date => {
    totalSvinn += this.getSvinn(date, category);
  });
  let total = totalSale + totalSvinn;
  return Number(((totalSvinn/total)*100).toFixed(2)) < 0 ? 0 : Number(((totalSvinn/total)*100).toFixed(2));
}

getProgressColor(category): string {
  
  let totalSale = 0;
  this.dates.forEach(date => {
    totalSale += this.getSale(date, category);
  });


  let totalSvinn = 0;
  this.dates.forEach(date => {
    totalSvinn += this.getSvinn(date, category);
  });

  const cappedPercentage = Math.min(100, Math.max(0, Number(((totalSvinn/totalSale)*100).toFixed(2))));

  // HSL color model:
  // Hue goes from 120 (green) to 0 (red) as the percentage increases
  const hue = (120 - (120 * cappedPercentage) / 100); // 120° is green, 0° is red

  const saturation = 100; // Fully saturated colors
  const lightness = 50; // Normal lightness
  
  // Return the color as an HSL string
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

}
